// extracted by mini-css-extract-plugin
module.exports = {"title":"title__1aefR","image":"image__3Dda0","content":"content__3pQzA","contacts":"contacts__3bGTi","contact":"contact__15_bY","map":"map__2P0BS","margin":"margin__1iCCD"};